const d3 = require('d3')
// There is another file: bam-node-bdata-charts/utils/colors.js which has some colors and helper functions
// This is DB's attempt to standardize pitch type colors in one place

const pitchTypeAbbrevMap = {
    '4-SEAM FASTBALL': 'FF',
    'FOUR SEAMER': 'FF',
    '2-SEAM FASTBALL': 'FT',
    SINKER: 'SI',
    CUTTER: 'FC',
    CHANGEUP: 'CH',
    'SPLIT FINGER': 'FS',
    'SPLIT-FINGER': 'FS',
    SPLITTER: 'FS',
    SCREWBALL: 'SC',
    FORKBALL: 'FO',
    SWEEPER: 'ST',
    SLIDER: 'SL',
    SLURVE: 'SV',
    CURVEBALL: 'CU',
    'KNUCKLE CURVE': 'KC',
    'KNUCKLE BALL': 'KN',
    KNUCKLEBALL: 'KN',
    'SLOW CURVE': 'CS',
    FF: 'FF',
    FT: 'FT',
    SI: 'SI',
    FC: 'FC',
    CH: 'CH',
    FS: 'FS',
    SC: 'SC',
    FO: 'FO',
    ST: 'ST',
    SL: 'SL',
    SV: 'SV',
    CU: 'CU',
    KC: 'KC',
    KN: 'KN',
    CS: 'CS',
    GY: 'GY',
    // Special ones?
    SIFT: 'FT',
    CHFS: 'CH',
    CUKC: 'CU',
    ALL: 'ALL',
    FASTBALL: 'FASTBALL',
    OFFSPEED: 'OFFSPEED',
    BREAKING: 'BREAKING',
}

// Always provide textColor, optionally provide vizColor
const pitchTypeColors = {
    FF: {
        textColor: '#D22D49',
    },
    FT: {
        textColor: '#DE6A04',
    },
    SI: {
        textColor: '#FE9D00',
    },
    FC: {
        textColor: '#933F2C',
    },
    CH: {
        textColor: '#1DBE3A',
    },
    FS: {
        textColor: '#3BACAC',
    },
    SC: {
        textColor: '#60DB33',
    },
    FO: {
        textColor: '#55CCAB',
    },
    ST: {
        textColor: '#DDB33A', // <<== NEW
    },
    SL: {
        textColor: '#C3BD0E',
        vizColor: '#EEE716',
    },
    SV: {
        textColor: '#93AFD4',
    },
    GY: {
        textColor: '#FFFF99', // <<== NEW
    },
    CU: {
        textColor: '#00D1ED',
    },
    KC: {
        textColor: '#6236CD',
    },
    KN: {
        textColor: '#3C44CD',
    },
    CS: {
        textColor: '#0068FF', // <<== NEW
    },
    ALL: { textColor: '#f00' },
    FASTBALL: { textColor: '#f00' },
    OFFSPEED: { textColor: '#0f0' },
    BREAKING: { textColor: '#00f' },

    // Defaults to gray: Eephus/EP, Fastball/FA
}

function getPitchTypeColor(pitchType = '', useTextColor = true) {
    const upperPitchType = String(pitchType).toUpperCase()
    const pitchAbbrev = pitchTypeAbbrevMap[upperPitchType]
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType)
        return '#888888'
    }

    const { textColor, vizColor } = pitchTypeColors[pitchAbbrev]

    return useTextColor ? textColor : vizColor || textColor
}

function getPitchTypeOutlineColor(
    pitchType,
    useTextColor = true,
    darkerRatio = 1
) {
    const upperPitchType = String(pitchType).toUpperCase()
    const pitchAbbrev = pitchTypeAbbrevMap[upperPitchType]
    if (!pitchAbbrev) {
        // eslint-disable-next-line no-console
        console.log('pitchAbbrev not found for pitchType:', pitchType)
        return '#888888'
    }

    const { textColor, vizColor } = pitchTypeColors[pitchAbbrev]
    const returnColor = useTextColor ? textColor : vizColor || textColor

    return d3.color(returnColor).darker(darkerRatio).formatHex()
}

module.exports = {
    getPitchTypeColor,
    getPitchTypeOutlineColor,
}
